angular.module('impactx.ruleset').controller('RuleUserListCtrl', [
    '$routeParams',
    'selectedListItems',
    RuleUserListCtrl]);

function RuleUserListCtrl($routeParams, selectedListItems) {
    var self = this;

    self.getDetailLink = function () {
        var ruleUser = selectedListItems.getFirstSelectedItem();
        if (ruleUser) {
            if (ruleUser.attributes.isInvoiceRuleUser) {
                return "ruleuserinvoice/" + ruleUser.id;
            }
            else if (ruleUser.attributes.isMinAmountRuleUser) {
                return "ruleuserminamount/" + ruleUser.id;
            }
            else {
                return "ruleuser/" + ruleUser.id;
            }
        }
    };

    self.getNewDialogLink = function () {
        var subRoute = $routeParams.type;

        switch (subRoute) {
            case "invoice":
                return "#/ruleuserinvoice/0/";
            case "minamount":
                return "#/ruleuserminamount/0/";
            default:
                return "#/ruleuser/0/";
        }
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditRuleUser'
        },
    ];

    this.meta = {
        rowTemplate: 'modules/ruleset/templates/ruleuserlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/ruleset/listruleusers',
        ctrl: this,
        id: "ruleuserlist",
        valuesInteger: [{name: "ATPId", value: $routeParams.ATPId}],
        mainAction : {id:"new", link: self.getNewDialogLink() + $routeParams.ATPId , icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };
}